import axios from 'axios'
import { normalize, schema } from 'normalizr'
import CreateReducer from '../utils/createReducer'
import CreateActions from '../utils/createActions'
import { mergeEntities, mergeAll } from '../utils/mergeNormalized'
import networkWrapper from '../utils/networkWrapper'
import api from '../api'

import selectors from '../selectors'
import snackbarActions from './snackbar'
import routerActions from './router'
import userActions from './user'

const client = new schema.Entity('client')

const prefix = 'client'

const initialState = {
  clients: normalize([], [client]),
}

const reducers = {
  setClients: (state, action) => {
    state.clients = normalize(action.payload, [client])
  },
  setClient: (state, action) => {
    mergeEntities(state.clients, normalize([action.payload], [client]))
  },
}

const loaders = {

  list: (state) => axios.get(api.projectUrl(state, '/client'))
    .then(api.process),

  get: (state, id) => axios.get(api.projectUrl(state, `/client/${id}`))
    .then(api.process),

  create: (state, data) => axios.post(api.projectUrl(state, `/client`), data)
    .then(api.process),

  save: (state, id, data) => axios.put(api.projectUrl(state, `/client/${id}`), data)
    .then(api.process),

  delete: (state, id) => axios.delete(api.projectUrl(state, `/client/${id}`))
    .then(api.process),

}

const sideEffects = {
  list: () => networkWrapper({
    prefix,
    name: 'list',
    handler: async (dispatch, getState) => {
      const data = await loaders.list(getState())
      dispatch(actions.setClients(data))
    },
    errorHandler: (dispatch, getState, errorMessage) => {
      dispatch(snackbarActions.setError(`there was an error listing the clients: ${errorMessage}`))
    }
  }),

  get: (id) => networkWrapper({
    prefix,
    name: 'get',
    handler: async (dispatch, getState) => {
      if(id == 'new') return
      const data = await loaders.get(getState(), id)
      dispatch(actions.setClient(data))
    },
    errorHandler: (dispatch, getState, errorMessage) => {
      dispatch(snackbarActions.setError(`there was an error getting a client: ${errorMessage}`))
    }
  }),

  save: (id, data) => networkWrapper({
    prefix,
    name: 'save',
    handler: async (dispatch, getState) => {
      const loader = id == 'new' ?
        () => loaders.create(getState(), data) :
        () => loaders.save(getState(), id, data)

      await loader()
      await dispatch(userActions.loadStatus())
      dispatch(snackbarActions.setSuccess(`client ${ id == 'new' ? 'created' : 'saved' }`))
      dispatch(routerActions.navigateTo('client.list'))
    },
    errorHandler: (dispatch, getState, errorMessage) => {
      dispatch(snackbarActions.setError(`there was an error saving the client: ${errorMessage}`))
    }
  }),

  delete: (id) => networkWrapper({
    prefix,
    name: 'delete',
    handler: async (dispatch, getState) => {
      await loaders.delete(getState(), id)
      dispatch(snackbarActions.setInfo(`client deleted`))
      dispatch(actions.list())
    },
    errorHandler: (dispatch, getState, errorMessage) => {
      dispatch(snackbarActions.setError(`there was an error deleting the client: ${errorMessage}`))
    }
  }),

}

const reducer = CreateReducer({
  initialState,
  reducers,
  prefix,
})

const actions = CreateActions({
  reducers,
  sideEffects,
  prefix,
})

export {
  actions,
  reducer,
}

export default actions